import React, { useState } from 'react';
import './ReportModal.css';
import { useTranslation } from 'react-i18next';
import { httpsCallable } from 'firebase/functions';
import { useAppContext } from '../AppContext';

export const ReportModal = ({ contentId, contentType, authorId, onClose, fullPath = null }) => {
    const { t } = useTranslation();
    const { appFunctions, setMessage } = useAppContext();
    const [reason, setReason] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!reason.trim()) {
            setMessage('Please provide a reason for the report.');
            return;
        }
        setIsSubmitting(true);
        try {
            const createReport = httpsCallable(appFunctions, 'createReport');
            await createReport({
                contentId,
                contentType,
                authorId,
                reason,
                contentSnippet: '', // Snippet can be added on the backend if needed
                fullPath
            });
            setMessage('Report submitted successfully. Our moderation team will review it.');
            onClose();
        } catch (error) {
            setMessage(`Error submitting report: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="report-modal-backdrop" onClick={onClose}>
            <div className="report-modal-content" onClick={e => e.stopPropagation()}>
                <h2>Report Content</h2>
                <form onSubmit={handleSubmit}>
                    <textarea
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Please describe why you are reporting this content..."
                        required
                    />
                    <div className="modal-actions">
                        <button type="button" onClick={onClose} disabled={isSubmitting}>Cancel</button>
                        <button type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Submitting...' : 'Submit Report'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
